module.exports = __webpack_public_path__ + "static/media/toolbar-select.4c08642f.svg";